import React from 'react'
import styled from 'styled-components'

const AddProject = () => {
    return (
        <Add>
            <form>
                <Field>
                    <label>Project Name</label>
                    <input type="text" />
                </Field>
                <Field>
                    <label>Project Description</label>
                    <input type="text" />
                </Field>
                <Field>
                    <label>Enter Day Number</label>
                    <input type="number" />
                </Field>
                <Field>
                    <label>Enter Project Link</label>
                    <input type="text" />
                </Field>
                <Field>
                    <label>Enter Project Image (Desktop)</label>
                    <input type="file" />
                </Field>
                <Field>
                    <label>Enter Project Image (Mobile)</label>
                    <input type="file" />
                </Field>
                <Field>
                    <label>Enter Some Tags</label>
                    <input type="text" />
                </Field>
                <Field>
                    <input type="submit" />
                </Field>
            </form>
        </Add>
    )
}

const Add = styled.div`
    width: 100%;
    height: 100vh;
    background-color: cadetblue;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Field = styled.div`
    display: flex;
    flex-direction: column;

    & > input, label {
        font-size: 3rem;
    }
`;

export default AddProject
